module.exports = __webpack_public_path__ + "img/3.09100cd8.jpg";